import { RefreshCw, Stethoscope, Type } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEditor } from "@/components/editor/useEditorState";

// Shortcuts from the Properties panel to the AI tab (selective regeneration / fix).
export default function AiQuick({ kind }) {
  const { setUi } = useEditor();
  const open = (patch) => setUi({ rightTab: "ai", rightOpen: true, ...patch });
  return (
    <div className="px-4 pb-4 pt-1 space-y-1.5" data-testid="ai-quick">
      <p className="text-[11px] uppercase tracking-[0.14em] text-slate-500 font-medium">Con l'AI</p>
      <div className="grid grid-cols-1 gap-1.5">
        {kind === "section" && <Button size="sm" variant="outline" className="justify-start h-8" onClick={() => open({ aiMode: "regen", regenTarget: "section" })} data-testid="ai-quick-regen-section"><RefreshCw size={13} className="mr-2" />Rigenera sezione</Button>}
        {kind === "section" && <Button size="sm" variant="outline" className="justify-start h-8" onClick={() => open({ aiMode: "regen", regenTarget: "text" })} data-testid="ai-quick-regen-text"><Type size={13} className="mr-2" />Rigenera un testo</Button>}
        {kind === "page" && <Button size="sm" variant="outline" className="justify-start h-8" onClick={() => open({ aiMode: "regen", regenTarget: "page" })} data-testid="ai-quick-regen-page"><RefreshCw size={13} className="mr-2" />Rigenera pagina</Button>}
        <Button size="sm" variant="outline" className="justify-start h-8" onClick={() => open({ aiMode: "fix" })} data-testid="ai-quick-fix"><Stethoscope size={13} className="mr-2" />Correggi con AI</Button>
      </div>
    </div>
  );
}
